
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import StaffDashboard from '@/pages/StaffDashboard';

const Staff = () => {
  return (
    <Routes>
      <Route index element={<StaffDashboard />} />
      <Route path="*" element={<StaffDashboard />} />
    </Routes>
  );
};

export default Staff;
